/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/** Silhouette a placeholder takes. */
export enum SkeletonShape {
  /** A filled rectangle — thumbnails, tiles, cards. */
  BLOCK = "block",
  /** A short bar on a text line's height — titles, subtitles, metadata. */
  TEXT = "text",
  /** A circle — avatars, round channel logos. */
  CIRCLE = "circle"
}

export interface SkeletonProps {
  /** Silhouette to draw. Defaults to {@link SkeletonShape.BLOCK}. */
  shape?: SkeletonShape;
  /**
   * CSS length for the placeholder's width. Any unit the surrounding layout
   * uses is fine — the component never interprets it. Defaults to `100%`.
   */
  width?: string;
  /**
   * CSS length for the placeholder's height. Defaults to `100%` for a block,
   * and to a single text line's height for {@link SkeletonShape.TEXT}.
   */
  height?: string;
  /** Corner radius override. Defaults per {@link SkeletonProps.shape}. */
  radius?: string;
  /**
   * Position of this placeholder within its group, zero-based.
   *
   * Each step delays the pulse a little further, so a row of placeholders
   * shimmers across rather than blinking in unison — the cue that reads as
   * "loading" instead of "broken". Wraps after a fixed number of steps so a
   * long list's last placeholder is not seconds behind its first.
   */
  sequence?: number;
  /** CSS class name for additional styling. */
  className?: string;
}
